<script>
import DatePicker from 'vue2-datepicker'
import DateFormatter from '../../plugins/dateFormatter'
export default {
  components: { DatePicker },
  data() {
    return {
      dateValue: '',
      // custom lang
      lang: {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
        placeholder: {
          date: 'Select Date',
          dateRange: 'Select Date Range'
        }
      },
      // custom range shortcuts
      shortcuts: [
        {
          text: 'Apply',
          onClick:async () => {
          //  this.dateValue = [ new Date(), new Date() ]
          console.log(this.dateValue[0])
          console.log(DateFormatter(this.dateValue[1]))
          let date1 = DateFormatter(this.dateValue[0])
          let date2 =  DateFormatter(this.dateValue[1])
          this.$store.dispatch('SET_MAIN_ITEMS_SEARCH',{date1,date2});
          }
        }
      ],

    }
  }
}
</script> 
 
<template>
  <div>
    <date-picker v-model="dateValue" range :shortcuts="shortcuts" :lang="lang"></date-picker>
    
  </div>
</template>